
	// JQUERY.MAGNIFIC-POPUP
	if ($.fn.magnificPopup) {
		// image
		$('.image-popup').magnificPopup({type:'image'});
        $('.image-group-popup').each(function() {
            $(this).magnificPopup({
                delegate: 'a',
                type: 'image',
                gallery: {
                    enabled: true
                }
            });
        });
		// iframe
		$('.iframe-popup').magnificPopup({type:'iframe'});
    $('.iframe-group-popup').each(function() {
        $(this).magnificPopup({
            delegate: 'a',
            type: 'iframe',
            gallery: {
                enabled: true
            }
        });
    });


		$('.gallery-wrapper').magnificPopup({
				delegate: 'div a',
				type: 'image',
				gallery: {
						enabled: true,
						//navigateByImgClick: true
				},
				//fixedContentPos: false
		});

	}
